<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";
import axios from "axios";
import DataTable from "@/components/DataTable.vue";

/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "Reconciliation Summary Details",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },
  data() {
    return {
      title: "Reconciliation Summary Report",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Reconciliation Summary Report",
          active: true,
        },
      ],
      pageOptions: [10, 25, 50, 100, 200, 1000],
      IsReconciliationReportSummaryServerPaginated: true,
      serverPerPage: 50,
      filter: null,
      filterOn: [],
      sortDesc: false,
      currentdate: moment(new Date()).format("DD-MM-YYYY"),
      filterProducts: {
        category: "",
        product: "",
        branch_id: 0,
        datefrom: moment().subtract(1, "months").format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        page: 1,
        per_page: 50,
      },
      is_exporting: false,

      // summaryColumns moved to computed properties

      json_fields: {
        PRODUCT: "product",
        FROM_QUANTITY: "from",
        TO_QUANTITY: "to",
        VARIANCE: "diff",
        PRICE: "price",
        VARIANCE_AMOUNT: "amount",
        DATE: "date",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
      exportReconciliationSummary() {
        this.is_exporting = true;
        axios
          .post("reconciliation-summary/export", this.filterProducts, {
            responseType: "arraybuffer",
          })
          .then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", "reconciliation-summary.xlsx");
            document.body.appendChild(fileLink);
            fileLink.click();
            this.is_exporting = false;
          })
          .catch(() => {
            this.is_exporting = false;
          });
      },
    };
  },
  computed: {
    ...mapGetters("stock", [
      "ReconciliationReportSummaryPagination",
      "ReconciliationReportSummarySummary",
      "ReconciliationReportSummaryPaginated",
      "FilterStatus",
    ]),
    ...mapGetters("auth", ["branchid", "Branches"]),
    ...mapGetters("setting", ["GeneralSettings", "BusinessSettings"]),

    rows() {
      return this.IsReconciliationReportSummaryServerPaginated
        ? this.ReconciliationReportSummaryPagination.total
        : this.ReconciliationReportSummaryPaginated
        ? this.ReconciliationReportSummaryPaginated.length
        : 0;
    },

    perPage: {
          get() {
            if (this.IsReconciliationReportSummaryServerPaginated) {
              return (
                (this.ReconciliationReportSummaryPagination && this.ReconciliationReportSummaryPagination.per_page) ||
                this.filterProducts.per_page ||
                this.serverPerPage
              );
            } else {
              return this.serverPerPage;
            }
          },
          set(value) {
            if (this.IsReconciliationReportSummaryServerPaginated) {
              this.filterProducts.per_page = value;
              this.filterProducts.page = 1;
              this.FetchReportData(this.filterProducts);
            } else {
              this.serverPerPage = value;
            }
          },
        },

      currentPage: {
        get() {
          return this.ReconciliationReportSummaryPaginated && this.ReconciliationReportSummaryPagination
            ? this.ReconciliationReportSummaryPagination.current_page
            : 1;
        },
          set(value) {
            if (this.ReconciliationReportSummaryPaginated) {
              this.filterProducts.page = value;
              this.handlePageChange(value);
            }
          },
        }, 

    isLoading() {
      return this.FilterStatus;
    },

    // Build columns dynamically based on settings
    summaryColumns() {
      const cols = [
        { key: "sn", label: "S/N" },
        { key: "product", label: "PRODUCT" },
        { key: "from", label: "FROM" },
        { key: "to", label: "TO" },
        { key: "diff", label: "DIFFERENCE" },
        { key: "price", label: "PRICE" },
        { key: "amount", label: "AMOUNT" },
        { key: "date", label: "DATE" },
      ];

      // Conditionally push extra columns depending on settings
      if (this.branchid === 0) {
        cols.push({ key: "branch", label: "BRANCH" });
      }
      if (this.GeneralSettings?.track_expiries === 1) {
        cols.push({ key: "batch_number", label: "BATCH NUMBER" });
      }
      if (
        this.BusinessSettings &&
        (this.BusinessSettings.store === 1 ||
          this.BusinessSettings.consumables === 1)
      ) {
        cols.push({ key: "category", label: "CATEGORY" });
      }

      return cols;
    },
  },
  methods: {
    ...mapActions({
      FetchReportData: "stock/fetchReconciliationReportSummaryData",
      FetchBranches: "auth/fetchBranches",
      FetchGeneralSettings: "setting/fetchGeneralSettings",
      FetchBusinessSettings: "setting/fetchBusinessSettings",
    }),

    onFiltered() {
      if (!this.IsReconciliationReportSummaryServerPaginated) {
        this.clientCurrentPage = 1;
      }
    },

    FilterReport() {
      this.filterProducts.page = 1;
      this.FetchReportData(this.filterProducts);
    },

     handlePageChange(newPage) {
        if (this.IsReconciliationReportSummaryServerPaginated) {
        this.filterProducts.page = newPage;
        this.FetchReportData(this.filterProducts);
      }
    },

    calculateIndex(index) {
      if (this.IsReconciliationReportSummaryServerPaginated) {
        return this.ReconciliationReportSummaryPagination.from - 1 + index;
      } else {
        return this.clientPerPage * (this.clientCurrentPage - 1) + index;
      }
    },
  },
  created() {
    this.FetchGeneralSettings();
    this.FetchBusinessSettings();
    this.FetchReportData(this.filterProducts);
    this.FetchBranches();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 mb-2">
                <b-button
                  variant="info"
                  class="me-2"
                  @click="exportReconciliationSummary()"
                  :disabled="is_exporting"
                >
                  <span v-if="!is_exporting">
                    Export Excel <i class="fa fa-download"></i>
                  </span>
                  <span v-else>
                    <b-spinner small></b-spinner> Exporting...
                  </span>
                </b-button>
              </div>
              <div class="col-md-5 mb-2" v-if="branchid == 0">
                <label>FILTER BY BRANCHES</label>
                <model-list-select
                  :list="Branches ? Branches : []"
                  v-model="filterProducts.branch_id"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Branch"
                  @input="FilterReport()"
                >
                </model-list-select>
              </div>
              <div
                class="col-md-3 mb-2"
                v-if="
                  BusinessSettings &&
                  (BusinessSettings.store == 1 ||
                    BusinessSettings.consumables == 1)
                "
              >
                <label>FILTER BY CATEGORY</label>
                <select
                  v-model="filterProducts.category"
                  @change="FilterReport()"
                  class="form-control"
                >
                  <option value="">All Categories</option>
                  <option value="0">Shop</option>
                  <option value="1" v-if="BusinessSettings.store == 1">
                    Store
                  </option>
                  <option value="2" v-if="BusinessSettings.consumables == 1">
                    Consumables
                  </option>
                </select>
              </div>
              <div class="col-md-3 mt-4">
                <b-button class="btn-warning text-white"
                  ><router-link :to="'/unreconcileditems'"
                    ><i class="fa fa-list"></i> Not Reconciled
                  </router-link></b-button
                >
              </div>
            </div>
            <div class="row mt-4 mb-4">
              <div class="col-sm-12 col-md-3 d-flex align-items-end">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center mb-0">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <div class="col-sm-6 col-md-2 d-flex align-items-end">
                <div class="form-group mb-0 w-100">
                  <label class="mb-0">From</label>
                  <input
                    type="date"
                    v-model="filterProducts.datefrom"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>

              <div class="col-sm-6 col-md-3 d-flex align-items-end">
                <div class="form-group mb-0 w-100">
                  <label class="mb-0">To</label>
                  <input
                    type="date"
                    v-model="filterProducts.dateto"
                    class="form-control"
                    v-limit-future-date
                  />
                </div>
              </div>

              <div class="col-sm-12 col-md-4 d-flex align-items-end">
                <div class="w-100">
                  <label class="mb-0">Search Product</label>
                  <div class="input-group">
                    <input
                      v-model="filterProducts.product"
                      type="text"
                      class="form-control"
                      placeholder="Enter product name or code"
                      @keyup.enter="FilterReport()"
                    />
                    <div class="input-group-append">
                      <button
                        class="btn btn-primary"
                        type="button"
                        @click="FilterReport()"
                      >
                        <b-spinner
                          v-if="FilterStatus"
                          variant="light"
                          small
                          label="Searching"
                        ></b-spinner>
                        <span>Search</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                :columns="summaryColumns"
                :rows="
                  ReconciliationReportSummaryPaginated
                    ? ReconciliationReportSummaryPaginated
                    : []
                "
                :total-rows="rows"
                :pagination="ReconciliationReportSummaryPagination"
                :server-pagination="
                  IsReconciliationReportSummaryServerPaginated
                "
                :loading="FilterStatus"
                row-class="summary-bordered"
              >
                <!-- S/N -->
                <template #cell(sn)="{ index }">
                  {{ calculateIndex(index) + 1 }}
                </template>

                <!-- PRODUCT -->
                <template #cell(product)="{ row }">
                  {{ row.product }}
                </template>

                <!-- FROM -->
                <template #cell(from)="{ row }">
                  {{ row.from }} {{ row.baseunit }}
                </template>

                <!-- TO -->
                <template #cell(to)="{ row }">
                  {{ row.to }} {{ row.baseunit }}
                </template>

                <!-- DIFFERENCE -->
                <template #cell(diff)="{ row }">
                  {{ row.diff }} {{ row.baseunit }}
                </template>

                <!-- PRICE -->
                <template #cell(price)="{ row }">
                  {{ row.price }}
                </template>

                <!-- AMOUNT -->
                <template #cell(amount)="{ row }">
                  {{ row.amount }}
                </template>

                <!-- DATE -->
                <template #cell(date)="{ row }">
                  {{ row.date }}
                </template>

                <!-- BRANCH -->
                <template #cell(branch)="{ row }" v-if="branchid == 0">
                  {{ row.branch }}
                </template>

                <!-- BATCH NUMBER -->
                <template
                  #cell(batch_number)="{ row }"
                  v-if="GeneralSettings?.track_expiries == 1"
                >
                  {{ row.batch_number }}
                </template>

                <!-- CATEGORY -->
                <template
                  #cell(category)="{ row }"
                  v-if="
                    BusinessSettings &&
                    (BusinessSettings.store == 1 ||
                      BusinessSettings.consumables == 1)
                  "
                >
                  {{ row.category }}
                </template>
              </DataTable>

              <div class="row">
                <div class="col-md-4"></div>
                <div class="col-md-4">
                  <h5>
                    Total Variance:
                    <span class="text-danger">
                      {{
                        ReconciliationReportSummarySummary &&
                        ReconciliationReportSummarySummary.total_variance_amount
                          ? parseInt(
                              ReconciliationReportSummarySummary.total_variance_amount
                                .toString()
                                .replaceAll(/,/g, "")
                            ).toLocaleString()
                          : "0"
                      }}
                    </span>
                  </h5>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      aria-controls="reconciliation-summary-table"
                      class="btn-warning"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
